import React from 'react';
import { Autocomplete, Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { isAutocompleteOption } from '@epi-helpers/AutocompleteHelper';
import { IBeneficiariesFilters } from '@epi-models/pages/Beneficiaries';

export const BeneficiariesFilters = ({
  employeesOptions,
  selectedBenefitGroup,
  benefitGroupOptions,
  selectedEmploymentType,
  employmentTypeOptions,
  handleEmployeesChange,
  handleGroupChange,
  handleEmploymentTypeChange
}: IBeneficiariesFilters) => {
  const { t } = useTranslation();

  return (
    <Box display="flex">
      <Box flex="0 0 25%" mr={3}>
        <Autocomplete
          multiple
          label={t('employees.filter.employees')}
          onChange={handleEmployeesChange}
          noOptionsText={t('employees.filter.no_options')}
          limitTags={1}
          options={employeesOptions}
          getOptionKey={option => {
            if (isAutocompleteOption(option)) return `${option.value}`;
            return `${option}`;
          }}
        />
      </Box>
      <Box flex="0 0 25%" mr={3}>
        <Autocomplete
          label={t('employees.filter.benefit_groups')}
          value={selectedBenefitGroup || null}
          onChange={handleGroupChange}
          noOptionsText={t('employees.filter.no_options')}
          options={benefitGroupOptions}
        />
      </Box>
      <Box flex="0 0 25%" mr={3}>
        <Autocomplete
          label={t('employees.filter.employment_types')}
          value={selectedEmploymentType || null}
          onChange={handleEmploymentTypeChange}
          noOptionsText={t('employees.filter.no_options')}
          options={employmentTypeOptions}
        />
      </Box>
    </Box>
  );
};
